// src/plugins/sdk/useAI.ts — AI calls are gated on `call:ai` and go through the existing proxy.
// Plugins never touch an Anthropic key directly; they can't bypass the proxy either.
import { usePluginId } from './PluginContext';
import { requirePermission } from '../permissions';
import { aiGenerate } from '../../ai/client';
export function useAI() {
    const pluginId = usePluginId();
    return async function generate(input) {
        requirePermission(pluginId, 'call:ai');
        // Every plugin AI call is attributed via a prompt_id that includes the plugin id.
        // This shows up in admin_events / ai_calls so you can see exactly which plugin
        // spent AI budget.
        const promptId = input.prompt_id ?? `plugin:${pluginId}:default`;
        return aiGenerate({ ...input, prompt_id: promptId });
    };
}
